"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.1881 12.617-1.687.975 1.324 2.317c.531.931.09 1.692-.982 1.692h-2.922v-1.949l-2.921 2.924 2.921 2.924v-1.949h2.922c1.223 0 2.236-.535 2.777-1.468.541-.933.503-2.078-.105-3.141l-1.327-2.325zm-14.014 3.292 1.305-2.285 1.652.954-1.07-3.994-3.99 1.07 1.721.995-1.308 2.293c-.608 1.063-.646 2.208-.105 3.141.541.933 1.554 1.468 2.777 1.468h3.895v-1.95h-3.895c-1.072 0-1.513-.761-.982-1.692zm2.035-7.493L9.342 4.68C9.952 3.613 10.92 3 12 3c1.079 0 2.047.613 2.657 1.68l2.116 3.706 1.714-.99-1.07 3.994-3.991-1.07 1.659-.959-2.119-3.713c-.5328-.9333-1.4018-.9307-1.933 0L8.896 9.391l-1.687-.975z"
  })];
};

exports.default = _default;